import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Driver } from "../../drivers.types";
import { requestGetDrivers } from "./getDrivers.request";

const useGetDrivers = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<Driver>, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();
  const QUERY_KEY = ["driver", "admin", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => await requestGetDrivers(requestParams),
    ...options
  });

  const setDrivers = (newDrivers: Driver[]) => {
    queryClient.setQueriesData(QUERY_KEY, {
      data: newDrivers,
      meta: data?.meta
    });
  };

  return { drivers: data?.data, meta: data?.meta, ...rest, setDrivers };
};

export default useGetDrivers;
